import {
  Button,
  Card,
  DatePicker,
  Dialog,
  Form,
  Input,
  NumberPicker,
  Radio,
} from '@alifd/next';
import { DeleteOutlined } from '@ant-design/icons';
import { message, Space, TimePicker, Typography } from 'antd';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';

import { getAnnouncementType } from '@/helpers/getAnnouncementType';

import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const RadioGroup = Radio.Group;

const PublicInformationSetting = ({ setIsStatusUpdate }) => {
  const communityData = client.service('communityData');
  const uploads = client.service('uploads');
  const announcement = client.service('announcement');
  const uploadRef = useRef(null);
  const uploadAnnouncement = useRef(null);
  const [communityDataArr, setCommunityDataArr] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [disable, setDisable] = useState(true);
  const [uploadPath, setUploadPath] = useState('');
  const [uploadData, setUploadData] = useState(null);
  const [announcementDialog, setAnnouncementDialog] = useState(false);
  const [announcementObject, setAnnouncementObject] = useState({});
  const [uploadAnnouncementPath, setUploadAnnouncementPath] = useState('');
  const [uploadAnnouncementData, setUploadAnnouncementData] = useState(null);
  const [visitorFile, setVisitorFile] = useState({});
  const [userName, setUserName] = useState('');

  useEffect(() => {
    (async () => {
      const result = await communityData.find({ query: {} });
      setCommunityDataArr(result.data[0]);
      setVisitorFile(result.data[0].visitorFile);
      const userData = await client.reAuthenticate();
      setUserName(userData.user.name);
    })();
  }, [isUpdate, communityData]);

  return (
    <>
      {/* 訪客參數設定 */}
      <Card free className={styles.publicSetting}>
        <Card.Content>
          <h3>訪客門禁預約管理辦法</h3>
          <div style={{ marginBottom: 10 }}>
            1.設定訪客車牌時效為
            <TimePicker
              style={{ width: '20%' }}
              disabled={disable}
              format="HH小時mm分鐘"
              value={moment(
                moment().startOf('day').valueOf() +
                  Number(communityDataArr.visitorLicense)
              )}
              onChange={(value) => {
                const newObject = { ...communityDataArr };
                newObject.visitorLicense =
                  moment(value).valueOf() - moment().startOf('day').valueOf();
                setCommunityDataArr(newObject);
              }}
            />
          </div>

          <div style={{ marginBottom: 10 }}>
            2.設定訪客辨識時效為
            <TimePicker
              style={{ width: '20%' }}
              disabled={disable}
              format="HH小時mm分鐘"
              value={moment(
                moment().startOf('day').valueOf() +
                  Number(communityDataArr.visitorFace)
              )}
              onChange={(value) => {
                const newObject = { ...communityDataArr };
                newObject.visitorFace =
                  moment(value).valueOf() - moment().startOf('day').valueOf();
                setCommunityDataArr(newObject);
              }}
            />
          </div>

          <div style={{ marginBottom: 10 }}>
            3.設定訪客卡片時效為
            <TimePicker
              style={{ width: '20%' }}
              disabled={disable}
              format="HH小時mm分鐘"
              value={moment(
                moment().startOf('day').valueOf() +
                  Number(communityDataArr.visitorCard)
              )}
              onChange={(value) => {
                const newObject = { ...communityDataArr };
                newObject.visitorCard =
                  moment(value).valueOf() - moment().startOf('day').valueOf();
                setCommunityDataArr(newObject);
              }}
            />
          </div>
          <div style={{ marginBottom: 10 }}>
            4.是否開放管理員審核：
            <RadioGroup
              disabled={disable}
              value={
                communityDataArr?.isAdminReview ||
                communityDataArr.isAdminReview
                  ? 'true'
                  : 'false'
              }
              onChange={(value) => {
                const newValue = value === 'true';
                const newObject = { ...communityDataArr };
                newObject.isAdminReview = newValue;
                setCommunityDataArr(newObject);
              }}
            >
              <Radio value="true">是</Radio>
              <Radio value="false">否</Radio>
            </RadioGroup>
          </div>
          <div style={{ marginBottom: 10 }}>
            5.開放住戶每日預約次數：
            <NumberPicker
              disabled={disable}
              min={0}
              defaultValue={0}
              value={
                communityDataArr?.visitorNum ? communityDataArr.visitorNum : 0
              }
              onChange={(value) => {
                const newObject = { ...communityDataArr };
                newObject.visitorNum = value;
                setCommunityDataArr(newObject);
              }}
            />
            次
          </div>
          <div style={{ marginBottom: 10 }}>
            <Space wrap>
              <Button
                disabled={disable}
                style={{ marginRight: 10 }}
                onClick={() => {
                  uploadRef.current.click();
                }}
              >
                {communityDataArr?.visitorFile?.name ? '更換檔案' : '檔案上傳'}
              </Button>
              {uploadData && (
                <>
                  <Typography.Text type="secondary">
                    {uploadData.name}
                  </Typography.Text>
                  <Button
                    disabled={disable}
                    text
                    onClick={() => {
                      setUploadData(null);
                      setUploadPath('');
                    }}
                    style={{ opacity: 0.45 }}
                  >
                    <DeleteOutlined style={{ marginLeft: 10 }} />
                  </Button>
                </>
              )}
              {!uploadData && communityDataArr?.visitorFile?.name && (
                <>
                  <Typography.Text type="secondary">
                    {communityDataArr?.visitorFile?.name}
                  </Typography.Text>
                  <Button
                    disabled={disable}
                    text
                    onClick={() => {
                      const newObject = { ...communityDataArr };
                      newObject.visitorFile = null;
                      setCommunityDataArr(newObject);
                    }}
                    style={{ opacity: 0.45 }}
                  >
                    <DeleteOutlined style={{ marginLeft: 10 }} />
                  </Button>
                </>
              )}
            </Space>
            <input
              ref={uploadRef}
              type="file"
              id="upload"
              value={uploadPath || ''}
              style={{ display: 'none' }}
              onChange={(e) => {
                const file = e.target.files[0];
                setUploadData(file);
                setUploadPath(e.target.value);
              }}
            />
          </div>
          <div style={{ marginBottom: 10, textAlign: 'right' }}>
            {disable === true && (
              <Button
                style={{ marginRight: 10 }}
                onClick={() => {
                  setAnnouncementDialog(true);
                  const defaultValue = {
                    title: '更新訪客門禁管理制度',
                    announcementTime: moment(),
                    content: `1.變更訪客車牌時效為${moment(
                      moment().startOf('day').valueOf() +
                        communityDataArr.visitorFace
                    ).format('HH小時mm分鐘')}。\n2.變更訪客辨識時效為${moment(
                      moment().startOf('day').valueOf() +
                        communityDataArr.visitorFace
                    ).format('HH小時mm分鐘')}。\n3.變更訪客卡片時效為${moment(
                      moment().startOf('day').valueOf() +
                        communityDataArr.visitorCard
                    ).format('HH小時mm分鐘')}。\n${
                      communityDataArr.isAdminReview
                        ? '4.訪客預約需通過管理員審核'
                        : '4.訪客預約不需通過管理員審核`'
                    }。\n5.開放住戶每日預約次數為${
                      communityDataArr?.visitorNum
                        ? communityDataArr.visitorNum
                        : 0
                    }人。`,
                  };
                  setAnnouncementObject(defaultValue);
                  setVisitorFile(communityDataArr?.visitorFile);
                }}
              >
                發佈公告
              </Button>
            )}
            <Button
              type="secondary"
              onClick={async () => {
                setDisable((pre) => !pre);
                console.log(communityDataArr);
                if (disable === false) {
                  try {
                    let NewVisitorFile = communityDataArr?.visitorFile?.name
                      ? communityDataArr.visitorFile
                      : {};
                    if (communityDataArr?.visitorFile?.name && uploadData) {
                      await uploads.remove(communityDataArr.visitorFile.id);
                    }
                    if (uploadData) {
                      const body = new FormData();
                      body.append('files', uploadData);
                      const res = await fetch(
                        '/newUploads?type=communityData',
                        {
                          method: 'POST',
                          body,
                          headers: {
                            authorization: window.localStorage['feathers-jwt'],
                          },
                        }
                      );
                      const { showPath, _id } = await res.json();
                      NewVisitorFile = {
                        path: showPath,
                        name: uploadData.name,
                        id: _id,
                      };
                    }
                    await communityData.patch(communityDataArr._id, {
                      ...communityDataArr,
                      visitorFile: NewVisitorFile,
                    });
                    setIsUpdate((pre) => !pre);
                    setIsStatusUpdate((pre) => !pre);
                    message.success('已更新設定參數');
                  } catch (error) {
                    message.error('更新失敗');
                  }
                }
              }}
            >
              {disable === true ? '編輯' : '完成'}
            </Button>
          </div>
        </Card.Content>
      </Card>
      {/* 發佈公告 */}
      <Dialog
        hasMask
        className={styles.announcementDialog}
        visible={announcementDialog}
        onOk={async () => {
          // form1.submit();
          let newAnnounceFile = {};
          if (uploadAnnouncementData) {
            const isImage = uploadAnnouncementData.type.includes('image');
            const body = new FormData();
            body.append('files', uploadAnnouncementData);
            const res = await fetch(
              isImage
                ? '/newUploads?type=announcement'
                : '/newUploads?type=announcement&isConvertPng=true',
              {
                method: 'POST',
                body,
                headers: {
                  authorization: window.localStorage['feathers-jwt'],
                },
              }
            );

            newAnnounceFile = await res.json();
          }
          console.log(newAnnounceFile);

          const announcementType = await getAnnouncementType(newAnnounceFile);

          try {
            const announcementData = {
              ...announcementObject,
              announcementTime: moment(
                announcementObject.announcementObject
              ).valueOf(),
              createdTime: moment().valueOf(),
              updatedTime: moment().valueOf(),
              type: '一般公告',
              fileType: announcementType,
              files:
                Object.keys(newAnnounceFile).length === 0
                  ? []
                  : [
                      {
                        name: visitorFile?.name
                          ? visitorFile.name
                          : newAnnounceFile.name,
                        response: {
                          ...(visitorFile?.name
                            ? {
                                oldName: visitorFile.name,
                                showPath: visitorFile.path,
                                id: visitorFile.id,
                              }
                            : newAnnounceFile[0]),
                        },
                      },
                    ],
              allows: [],
              broadcastStatus: false,
              broadcastGroupId: null,
              calendarStatus: false,
              calendarId: null,
              MessageStatus: false,
              checkedStatus: false,
              announcer: userName,
              endTime: moment().endOf('M').valueOf(),
            };

            announcement.create(announcementData);

            //連動更新communityData
            await communityData.patch(communityDataArr._id, {
              ...communityDataArr,
              visitorFile: {
                path: newAnnounceFile.showPath,
                name: newAnnounceFile.oldName,
                id: newAnnounceFile._id,
              },
            });
            setIsUpdate((pre) => !pre);
            setAnnouncementDialog(false);
            message.success('新增成功');
          } catch (error) {
            console.log(error);
          }
        }}
        onCancel={() => {
          setAnnouncementDialog(false);
        }}
        onClose={() => {
          setAnnouncementDialog(false);
        }}
      >
        <Form
          //   form={form1}
          name="basic"
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          //   onFinish={onFinishAnnouncement}
          autoComplete="off"
        >
          <h3>新增公告</h3>
          <Form.Item
            label="發佈時間"
            name="announcementTime"
            // required
            // requiredMessage="請選擇發佈時間"
          >
            <DatePicker
              showTime={{ format: 'HH:mm:ss' }}
              value={moment(announcementObject.announcementTime)}
              onChange={(value) => {
                const newObject = { ...announcementObject };
                newObject.announcementTime = moment(value).valueOf();
                setAnnouncementObject(newObject);
              }}
            />
          </Form.Item>
          <Form.Item
            label="標題"
            name="title"
            required
            requiredMessage="請輸入標題"
          >
            <Input
              value={announcementObject.title}
              onChange={(value) => {
                const newObject = { ...announcementObject };
                newObject.title = value;
                setAnnouncementObject(newObject);
              }}
            />
          </Form.Item>

          <Form.Item
            label="內容"
            name="content"
            required
            requiredMessage="請輸入內容"
          >
            <Input.TextArea
              value={announcementObject.content}
              aria-label="TextArea"
              onChange={(value) => {
                const newObject = { ...announcementObject };
                newObject.content = value;
                setAnnouncementObject(newObject);
              }}
            />
          </Form.Item>
          <Form.Item label="檔案上傳">
            <Space wrap>
              <Button
                style={{ marginRight: 10 }}
                onClick={() => {
                  uploadAnnouncement.current.click();
                }}
              >
                上傳
              </Button>
              {uploadAnnouncementData && (
                <>
                  <Typography.Text type="secondary">
                    {uploadAnnouncementData.name}
                  </Typography.Text>
                  <Button
                    text
                    onClick={() => {
                      setUploadAnnouncementData(null);
                      setUploadAnnouncementPath('');
                    }}
                    style={{ opacity: 0.45 }}
                  >
                    <DeleteOutlined style={{ marginLeft: 10 }} />
                  </Button>
                </>
              )}
              {!uploadAnnouncementData && visitorFile?.name && (
                <>
                  <Typography.Text type="secondary">
                    {communityDataArr?.visitorFile?.name}
                  </Typography.Text>
                  <Button
                    text
                    onClick={() => {
                      setUploadAnnouncementData(null);
                      setUploadAnnouncementPath('');
                      setVisitorFile({});
                    }}
                    style={{ opacity: 0.45 }}
                  >
                    <DeleteOutlined style={{ marginLeft: 10 }} />
                  </Button>
                </>
              )}
            </Space>
            <input
              ref={uploadAnnouncement}
              type="file"
              id="upload"
              style={{ display: 'none' }}
              onChange={(e) => {
                const file = e.target.files[0];
                setUploadAnnouncementData(file);
                setUploadAnnouncementPath(e.target.value);
              }}
            />
          </Form.Item>
        </Form>
      </Dialog>
    </>
  );
};
export default PublicInformationSetting;
